<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <FinancialContractList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import FinancialContractList from '@/components/settings/financial/contract/FinancialContractList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'FinancialContractListView',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    FinancialContractList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addfinancialcontract' })
    }
  }
}
</script>
